import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  requestState: UiState.Idle
};

const fetchSystemConfigurationRequest = draft => {
  draft.requestState = UiState.Pending;
};

const fetchSystemConfigurationSuccess = (draft, action) => {
  draft.systemConfiguration = action.payload.systemConfiguration;
  draft.requestState = UiState.Success;
};

const fetchSystemConfigurationFailure = draft => {
  draft.requestState = UiState.Failure;
};

const systemConfigurationSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    fetchSystemConfigurationRequest,
    fetchSystemConfigurationSuccess,
    fetchSystemConfigurationFailure
  }
});
export const {
  actions
} = systemConfigurationSlice;
export const plug = {
  [stateName]: systemConfigurationSlice.reducer
};
export default systemConfigurationSlice.reducer;